import React from "react";

function ClicksMeticCard({ totalClicks }) {
  return (
    <div className="rounded-xl bg-white dark:bg-accent-800 overflow-hidden min-w-[384px] relative w-full border border-primary-50 shadow-sm dark:border-none">
      <div className="md:px-20px px-16px py-16px">
        <span className="absolute top-0 bottom-0 right-0">
          <svg
            width="207"
            height="170"
            viewBox="0 0 207 170"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_f_483_2515)">
              <path
                d="M117.629 158.916L104.016 125.795C99.3085 114.341 99.2898 102.9 103.96 91.4735C108.631 80.0468 116.633 71.9546 127.967 67.1968C139.302 62.439 150.622 62.4201 161.929 67.14C173.236 71.86 181.243 79.9472 185.951 91.4016L199.564 124.523L183.177 131.402L169.564 98.2803C166.728 91.3801 161.927 86.518 155.163 83.6941C148.398 80.8702 141.602 80.8913 134.774 83.7574C127.946 86.6236 123.135 91.4749 120.341 98.3114C117.546 105.148 117.567 112.016 120.403 118.916L134.016 152.038L117.629 158.916ZM140.193 120.318L156.58 113.439L183.807 179.682L167.42 186.561L140.193 120.318ZM124.436 175.477L140.823 168.598L154.436 201.72C157.272 208.62 162.073 213.482 168.837 216.306C175.602 219.13 182.398 219.109 189.226 216.243C196.054 213.376 200.865 208.525 203.659 201.689C206.454 194.852 206.433 187.984 203.597 181.084L189.984 147.962L206.371 141.084L219.984 174.205C224.691 185.659 224.71 197.1 220.04 208.526C215.369 219.953 207.367 228.045 196.033 232.803C184.699 237.561 173.378 237.58 162.071 232.86C150.764 228.14 142.757 220.053 138.049 208.598L124.436 175.477Z"
                className="dark:fill-secondary-600 fill-secondary-400"
              />
            </g>
            <path
              opacity="0.8"
              d="M152.629 147.512C144.278 147.077 137.232 143.859 131.49 137.856C125.749 131.854 122.878 124.633 122.878 116.195C122.878 107.496 125.923 100.102 132.012 94.0122C138.101 87.9228 145.496 84.878 154.195 84.878C162.633 84.878 169.854 87.7488 175.856 93.4902C181.858 99.2317 185.077 106.278 185.512 114.629L174.551 111.367C173.42 106.67 170.984 102.82 167.244 99.8189C163.503 96.8177 159.154 95.3171 154.195 95.3171C148.454 95.3171 143.538 97.3614 139.45 101.45C135.361 105.539 133.317 110.454 133.317 116.195C133.317 121.154 134.818 125.503 137.819 129.244C140.82 132.985 144.669 135.42 149.367 136.551L152.629 147.512ZM158.893 168.129C158.11 168.303 157.327 168.39 156.544 168.39H154.195C146.975 168.39 140.189 167.02 133.839 164.28C127.488 161.54 121.965 157.821 117.267 153.123C112.569 148.426 108.85 142.902 106.11 136.551C103.37 130.201 102 123.415 102 116.195C102 108.975 103.37 102.189 106.11 95.839C108.85 89.4886 112.569 83.9646 117.267 79.2671C121.965 74.5695 127.488 70.8506 133.839 68.1104C140.189 65.3701 146.975 64 154.195 64C161.415 64 168.201 65.3701 174.551 68.1104C180.901 70.8506 186.425 74.5695 191.123 79.2671C195.821 83.9646 199.539 89.4886 202.28 95.839C205.02 102.189 206.39 108.975 206.39 116.195V118.544C206.39 119.327 206.303 120.11 206.129 120.893L195.951 117.761V116.195C195.951 104.538 191.906 94.6646 183.816 86.5744C175.725 78.4841 165.852 74.439 154.195 74.439C142.538 74.439 132.665 78.4841 124.574 86.5744C116.484 94.6646 112.439 104.538 112.439 116.195C112.439 127.852 116.484 137.726 124.574 145.816C132.665 153.906 142.538 157.951 154.195 157.951H155.761L158.893 168.129ZM198.691 171L176.378 148.687L169.854 168.39L154.195 116.195L206.39 131.854L186.686 138.378L209 160.691L198.691 171Z"
              className="dark:fill-secondary-600 fill-secondary-400"
            />
            <defs>
              <filter
                id="filter0_f_483_2515"
                x="0.47139"
                y="-36.3858"
                width="323.057"
                height="372.772"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="50"
                  result="effect1_foregroundBlur_483_2515"
                />
              </filter>
            </defs>
          </svg>
        </span>
        <h1 className="dark:text-primary-400 text-base mb-10px text-accent-600 font-semibold">
          Links Total
        </h1>
        <div className="flex items-center md:gap-16px gap-10px">
          <h1 className="md:text-3xl text-2xl font-semibold dark:text-primary-200 text-secondary-600">
            {totalClicks}
          </h1>
          {/* <div className="flex gap-1 items-center py-[3px] px-[5px] dark:text-accent-700 text-white text-xs dark:bg-primary-400 bg-secondary-400 font-semibold">
            <span>
              <svg
                width="12"
                height="7"
                viewBox="0 0 12 7"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.816667 7L0 6.18333L4.31667 1.8375L6.65 4.17083L9.68333 1.16667H8.16667V0H11.6667V3.5H10.5V1.98333L6.65 5.83333L4.31667 3.5L0.816667 7Z"
                  className="dark:fill-accent-700 fill-white"
                />
              </svg>
            </span>
            <span>16%</span>
          </div> */}
        </div>
        <div className="flex mt-25px gap-16px">
          <div className="pe-16px border-e  dark:border-accent-500 border-primary-100">
            <p className="text-sm dark:text-primary-400 mb-2 leading-none text-accent-300">
              Today
            </p>
            <p className="dark:text-primary-300 text-secondary-600 leading-none">
              + <span className="font-semibold">{totalClicks}</span>
            </p>
          </div>
          <div className="pe-16px border-e  dark:border-accent-500 border-primary-100">
            <p className="text-sm dark:text-primary-400 mb-2 leading-none text-accent-300">
              This week
            </p>
            <p className="dark:text-primary-300 text-secondary-600 leading-none">
              + <span className="font-semibold">{totalClicks}</span>
            </p>
          </div>
          <div>
            <p className="text-sm dark:text-primary-400 mb-2 leading-none text-accent-300">
              This month
            </p>
            <p className="dark:text-primary-300 text-secondary-600 leading-none">
              + <span className="font-semibold">{totalClicks}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClicksMeticCard;
